import Api from '.';

/**
 * Retrieve all HealthHealthProfessionalal.
 */
export function getHealthProfessional(id) {
  return Api.get(`/professional/id/${id}`);
}

/**
 * Retrieve all HealthHealthProfessionalal.
 */
export function listHealthHealthProfessionalal() {
  return Api.get('/professional');
}

/**
 *
 * Retrieve health insurances by lazy list.
 */
export function lazyHealthProfessional({
  search,
  page,
  perPage,
  businessPartner,
  professionId,
  CBOCode
}) {
  search = search ? `&search=${search}` : '';
  page = page ? `&page=${page}` : '';
  perPage = perPage ? `&perPage=${perPage}` : '';
  businessPartner = businessPartner ? `&businessPartner=${businessPartner}` : '';
  professionId = professionId ? `&professionId=${professionId}` : '';
  CBOCode = CBOCode ? `&CBOCode=${CBOCode}` : '';

  return Api.get(
    '/professional/lazy?' + search + page + perPage + businessPartner + professionId + CBOCode
  );
}

/**
 *
 * Retrieve professionals by lazyLoad.
 * @param {object} search, page, perPage
 * @param {number} professionalId
 * @return {array} professionals by profession
 */
export function lazyHealthProfessionalByProfession({ search, page, perPage }, professionFilter) {
  return Api.get(
    `/professional/profession/${professionFilter}/lazy?search=${search}&page=${page}&perPage=${perPage}`
  );
}

/**
 *
 * create a HealthProfessional.
 */
export function createHealthProfessional(HealthProfessional) {
  return Api.post('/professional', HealthProfessional);
}

/**
 *
 * Update HealthProfessional.
 */
export function updateHealthProfessional(id, HealthProfessional) {
  return Api.put(`/professional/${id}`, HealthProfessional);
}

/**
 *
 * Update HealthProfessional status.
 */
export function reactivateHealthProfessionalStatus(id) {
  return Api.put(`/professional/${id}/reactivate`);
}

/**
 *
 * Update HealthProfessional status.
 */
export function deactivateHealthProfessionalStatus(id) {
  return Api.put(`/professional/${id}/deactivate`);
}
